import { render } from "@/components/pages/dataRecollection/allDtc/AllDtcPage.html?vue&type=template&id=e1ae21e0&external"
import script from "@/components/pages/dataRecollection/allDtc/AllDtcPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/allDtc/AllDtcPage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__